/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import RemoveEngineersForm from './RemoveEngineersForm/RemoveEngineersForm';
import RemoveEngineersSuccess from './RemoveEngineersSuccess/RemoveEngineersSuccess';
import RemoveEngineersError from './RemoveEngineersError/RemoveEngineersError';
import Form from '../../../../../forms/_.extend';

import Loading from 'components/Loading/Loading';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'userStore')
@observer
export default class RemoveEngineers extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const project: Object = this.props.project;

    const fields: Array<Object> = [
      {
        name: 'removeEngineers',
        label: t('general:actions.remove_project_from'),
        title: 'Remove Project From',
        fields: [
          {
            name: 'engineersIds',
            label: t('general:actions.remove'),
            rules: 'required|array',
            value: [],
            placeholder: t('general:first_last_name'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { engineersIds }: Object = data.values().removeEngineers;

        actionDrawerStore.removeEngineersFromProject(project.id, {
          ids: engineersIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Remove Project From',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { project, actionDrawerStore, userStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.remove_engineers_from_project')} />
          <RemoveEngineersError {...project} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.remove_engineers_from_project')} />
          <RemoveEngineersSuccess {...project} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.remove_engineers_from_project')} />
        <RemoveEngineersForm
          project={project}
          user={userStore.getActiveUserFromLocal()}
          form={this.createForm()}
        />
      </div>
    );
  }
}
